// this is an autogenerated file from DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/StatusUpdate/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_EditAutomation_EventActions_Content_EventAction_Content_Content_Content_StatusUpdate{
  vaxiom_tx_statuses(
    where: { hidden: { _eq: false } }
    order_by: { name: asc }
  ) {
    id
    type
    text: name
  }
}

`